var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[(!_vm.loaded)?_c('v-progress-linear',{attrs:{"color":"green","indeterminate":true}}):_c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.docs},scopedSlots:_vm._u([{key:"item.timestamp",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.timestamp.toDate()))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }